import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryClient } from '.';
import { type EditMaxLocations, type MaxLocations } from '../../shared/types';
import { deleteAdminMaxLocation, getAdminMaxLocations, postAdminMaxLocation, putAdminMaxLocation } from '../utilities/api';

export const queryKeys = {
    getAdminMaxLocations: () => ['admin', 'max-locations', 'get'],
};

export const useAdminMaxLocations = (): UseQueryResult<MaxLocations[], Error> => {
    return useQuery({ queryKey: queryKeys.getAdminMaxLocations(), queryFn: getAdminMaxLocations, staleTime: Infinity });
};

export const useUpdateAdminMaxLocation = () => {
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: EditMaxLocations }) => putAdminMaxLocation(id, data),
        onSuccess: (newLocation: MaxLocations) => {
            queryClient.setQueryData(queryKeys.getAdminMaxLocations(), (locations: MaxLocations[]) => {
                return locations.map((location) => (location._id === newLocation._id ? newLocation : location));
            });
        },
    });
};

export const useCreateAdminMaxLocation = () => {
    return useMutation({
        mutationFn: (data: EditMaxLocations) => postAdminMaxLocation(data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.getAdminMaxLocations() }),
    });
};

export const useDeleteAdminMaxLocation = () => {
    return useMutation({
        mutationFn: (id: string) => deleteAdminMaxLocation(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAdminMaxLocations() });
        },
    });
};
